import { AtributoRequest } from './atributo-request';
import { MotivoRequest } from "./motivo-request";

export class FinalidadeRequest {
  description: string;
  id:string;
  name: string;
  columnAttributes: AtributoRequest[];
  reasons: string[];
  
}
